import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseEmptyClientError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.purchase.validation.empty-client-error.message');
    }
}
